import { createBrowserRouter, Navigate } from 'react-router-dom'
import Interface from './interface'
import Usuario from './programas/usuario'
import ProgramaControle from './programas/administracao/programa'
import PerfilPermissao from './programas/administracao/perfilPermissao'
import TipoUsuario from './programas/administracao/tipoUsuario'
import Atendimento from './programas/atendimento/index.jsx'
import Contratante from './programas/administracao/contratante'
import LocalAtendimento from './programas/administracao/localAtendimento'
import Servico from './programas/cadastro/servico'
import Agenda from './programas/cadastro/agenda'
import Convenio from './programas/cadastro/convenio'
import Medico from './programas/cadastro/medico'
import Paciente from './programas/cadastro/paciente'
import { TipoAgendamentoCRUD } from './programas/cadastro/tipoAgendamento'
import AgendaCRUD from './programas/consultorio/agenda'
import AtendimentoMedico from './programas/consultorio/atendimentoMedico'
import Login from './interface/login/'
import RelatorioAtendimento from './programas/relatorio/atendimento'
import CaixaConsultorio from './programas/caixa'
import { FormaDePagamento } from './programas/caixa/formaDePagamento'
import Especialidade from './programas/cadastro/especialidade'
import AberturaAutoagendamento from './programas/consultorio/aberturaAutoagendamento'
import CategoriaConta from './programas/caixa/categoriaConta'
import { Dashboard } from './programas/dashboard'
import AutoAgendamentoOnline from './programas/consultorio/autoAgendamentoOnline'
import PlanoCRUD from './programas/plano/planos'
import TipoUsuarioSistema from './programas/administracao/tipoUsuarioSistema'
import Cliente from './programas/plano/cliente'
import Contrato from './programas/plano/contrato'
import MedicamentoCRUD from './programas/cadastro/medicamento'
import ViaAdministracaoCRUD from './programas/cadastro/viaAdministracao'
import GrupoAlimento from './programas/nutricao/grupoAlimento'
import Alimento from './programas/nutricao/alimento'
import ListaEspera from './programas/cadastro/listaEspera'
import MovimentoEstoque from './programas/estoque/movimentoEstoque'
import Fornecedor from './programas/estoque/fornecedor'
import Produto from './programas/estoque/produto'
import TipoMovimentoEstoque from './programas/estoque/tipoMovimentoEstoque'
import MovimentacaoFinanceira from './programas/financeiro/movimentacaoFinanceira'
import PlanoDeConta from './programas/financeiro/planoDeConta'
import CentroDeCusto from './programas/financeiro/centroDeCusto'
import ContaBancaria from './programas/financeiro/contaBancaria'
import ContasPagar from './programas/financeiro/contaPagar'
import Empresa from './programas/cadastro/empresa'
import EmpresaNotaFiscal from './programas/administracao/empresaNotaFiscal'
import TipoAtendimento from './programas/cadastro/tipoAtendimento'
import Terapia from './programas/cadastro/terapia'
import Quarto from './programas/cadastro/quarto'
import Proposta from './programas/comercial/proposta'
import TermoAceiteFramework from './programas/termoAceiteFramework'
import Equipamento from './programas/manutencao/equipamento'
import ManutencaoEquipamento from './programas/manutencao/manutencaoEquipamento'
import AutorizacaoDeAcesso from './programas/comercial/portaria'
import ContasReceber from './programas/financeiro/contaReceber'
import DashboardFinanceiro from './programas/financeiro/dashboard'
// import CaixaPontoDeVenda from './programas/financeiro/pontoDeVenda/caixa'
import CaixaFechamento from './programas/financeiro/fechamento/caixa'
import PontoDeVenda from './programas/financeiro/pontoDeVenda'
import Dispensacao from './programas/farmacia/dispensacao'
import ProgramacaoAgendamento from './programas/enfermagem/programacaoAgendamento'
import UsuarioEdicaoSenha from './programas/usuario/UsuarioEdicaoSenha'
import RespostaQuestionarioPublico from './programas/questionario/publico'
import ProdutoFluxoAtendimento from './programas/estoque/produtoFluxoAtendimento'
import ModeloDocumento from './programas/atendimento/modeloDocumento'
import OrcamentoCheckin from './programas/financeiro/orcamentoCheckin'
import FluxoAtendimento from './programas/atendimento/fluxoAtendimento'
import AplicacaoMedicamento from './programas/enfermagem/aplicacao'
import TermoConsentimentoPublico from './programas/publico/termoConsentimentoPublico'
import AgendamentoOnline from './programas/publico/agendamentoOnline'
import TesteCurvaCrescimento from './programas/publico/teste'
import AtendimentoExterno from './programas/enfermagem/atendimentoExterno'
import ProgramacaoAgendamentoCheckin from './programas/enfermagem/programacaoAgendamentoCkeckin'
import CtrlNotaFiscal from './programas/financeiro/notaFiscal'
import RelatorioAtendimentoCheckin from './programas/relatorio/relatorioCheckin'
import Checkout from './programas/financeiro/orcamentoCheckout'
import NotFound from './NotFound'
import RelatorioTransfer from './programas/relatorio/relatorioTransfer'
import RelatorioInformacoesHotelaria from './programas/relatorio/relatorioInformacoesHotelaria'
import RelatorioAplicacoesEnfermagem from './programas/relatorio/relatorioAplicacoesEnfermagem'
import CtrlQuestionario from './programas/administracao/questionario'
import RelatorioFichaComercial from './programas/relatorio/relatorioFichaComercial'
import ReceitasAvulsas from './programas/atendimento/receitasAvulsas'
import RelatorioAniversariantes from './programas/relatorio/aniversariantes'
import RelatorioProdutosAVencer from './programas/relatorio/produtosAVencer'
import RelatorioSaidasEstoque from './programas/relatorio/relatorioSaidasEstoque'
import ValidadorDocumento from './programas/publico/documento'
import GestaoDeComissoes from './programas/financeiro/comissao'
import RelatorioVendasPorCentroDeCusto from './programas/relatorio/relatorioVendasPorCentroDeCusto'
import RelatorioVendasPorPlanoDeConta from './programas/relatorio/relatorioVendasPorPlanoDeConta'
import RelatorioFluxoDeCaixa from './programas/relatorio/relatorioFluxoDeCaixa'
import RelatorioCheque from './programas/relatorio/relatorioCheque'
import Cheque from './programas/financeiro/cheque'
import Campanha from './programas/campanha/agenda'
import PacienteEvolucaoEnfermagem from './programas/enfermagem/pacienteEvolucaoEnfermagem'
import AtendimentoPortaria from './programas/comercial/atendimentoPortaria'
import RelatorioSinaisEvolucaoEnfermagem from './programas/relatorio/relatorioSinaisEvolucaoEnfermagem'
import RelatorioInformacoesFichaTerapia from './programas/relatorio/relatorioInformacoesFichaTerapias'
import AgenteLLM from './programas/cadastro/agente'
import RelatorioAdicionalAtendimento from './programas/relatorio/relatorioAdicionalAtendimento'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to="/login" replace />,
  },
  {
    path: '/programas',
    element: <Interface />,
    children: [
      {
        path: '*',
        element: <NotFound />,
      },
      { path: '/programas/dashboard', element: <Dashboard /> },
      { path: '/programas/usuario', element: <Usuario /> },
      {
        path: '/programas/administracao/programa',
        element: <ProgramaControle />,
      },
      {
        path: '/programas/administracao/empresa_nota_fiscal',
        element: <EmpresaNotaFiscal />,
      },
      {
        path: '/programas/administracao/perfilPermissao',
        element: <PerfilPermissao />,
      },
      {
        path: '/programas/administracao/tipoUsuario',
        element: <TipoUsuario />,
      },
      {
        path: '/programas/administracao/tipoUsuarioSistema',
        element: <TipoUsuarioSistema />,
      },
      { path: '/programas/atendimento', element: <Atendimento /> },
      {
        path: '/programas/administracao/contratante',
        element: <Contratante />,
      },
      {
        path: '/programas/administracao/localAtendimento',
        element: <LocalAtendimento />,
      },
      { path: '/programas/administracao/servico', element: <Servico /> },
      { path: '/programas/cadastro/agenda', element: <Agenda /> },
      { path: '/programas/cadastro/convenio', element: <Convenio /> },
      { path: '/programas/cadastro/medico', element: <Medico /> },
      {
        path: '/programas/cadastro/tipoAgendamento',
        element: <TipoAgendamentoCRUD />,
      },
      { path: '/programas/cadastro/paciente', element: <Paciente /> },
      { path: '/programas/consultorio/agenda', element: <AgendaCRUD /> },
      {
        path: '/programas/consultorio/atendimento_medico',
        element: <AtendimentoMedico />,
      },
      { path: '/programas/cadastro/servico', element: <Servico /> },
      {
        path: '/programas/relatorios/atendimento',
        element: <RelatorioAtendimento />,
      },
      {
        path: '/programas/caixa',
        element: <CaixaConsultorio />,
      },
      {
        path: '/programas/caixa/formaPagamento',
        element: <FormaDePagamento />,
      },
      {
        path: '/programas/cadastro/especialidade',
        element: <Especialidade />,
      },
      {
        path: '/programas/consultorio/aberturaAutoagendamento',
        element: <AberturaAutoagendamento />,
      },
      {
        path: '/programas/consultorio/autoAgendamentoOnline',
        element: <AutoAgendamentoOnline />,
      },
      {
        path: '/programas/caixa/categoriaConta',
        element: <CategoriaConta />,
      },
      {
        path: '/programas/financeiro/conta_a_pagar',
        element: <ContasPagar />,
      },
      {
        path: '/programas/financeiro/dashboard',
        element: <DashboardFinanceiro />,
      },
      {
        path: '/programas/financeiro/conta_a_receber',
        element: <ContasReceber />,
      },
      {
        path: '/programas/plano/planos',
        element: <PlanoCRUD />,
      },
      {
        path: '/programas/plano/cliente',
        element: <Cliente />,
      },
      {
        path: '/programas/plano/contrato',
        element: <Contrato />,
      },
      {
        path: '/programas/medicamento',
        element: <MedicamentoCRUD />,
      },
      {
        path: '/programas/viaAdministracao',
        element: <ViaAdministracaoCRUD />,
      },
      {
        path: '/programas/nutricao/grupoAlimento',
        element: <GrupoAlimento />,
      },
      {
        path: '/programas/nutricao/alimento',
        element: <Alimento />,
      },
      {
        path: '/programas/cadastro/listaEspera',
        element: <ListaEspera />,
      },
      {
        path: '/programas/estoque/movimento_estoque',
        element: <MovimentoEstoque />,
      },
      {
        path: '/programas/estoque/fornecedor',
        element: <Fornecedor />,
      },
      {
        path: '/programas/estoque/produto',
        element: <Produto />,
      },
      {
        path: '/programas/estoque/produto_fluxo_atendimento',
        element: <ProdutoFluxoAtendimento />,
      },
      {
        path: '/programas/estoque/tipo_movimento_estoque',
        element: <TipoMovimentoEstoque />,
      },
      {
        path: '/programas/financeiro/movimentacao_financeira',
        element: <MovimentacaoFinanceira />,
      },
      {
        path: '/programas/financeiro/plano_de_conta',
        element: <PlanoDeConta />,
      },
      {
        path: '/programas/financeiro/centro_de_custo',
        element: <CentroDeCusto />,
      },
      {
        path: '/programas/financeiro/conta_cancaria',
        element: <ContaBancaria />,
      },
      {
        path: '/programas/cadastro/empresa',
        element: <Empresa />,
      },
      {
        path: '/programas/cadastro/tipo_atendimento',
        element: <TipoAtendimento />,
      },
      {
        path: '/programas/cadastro/terapia',
        element: <Terapia />,
      },
      {
        path: '/programas/cadastro/quarto',
        element: <Quarto />,
      },
      {
        path: '/programas/comercial/proposta',
        element: <Proposta />,
      },
      {
        path: '/programas/termo_aceite',
        element: <TermoAceiteFramework />,
      },
      {
        path: '/programas/manutencao/cadastro/equipamento',
        element: <Equipamento />,
      },
      {
        path: '/programas/manutencao/manutencao_equipamento',
        element: <ManutencaoEquipamento />,
      },
      {
        path: '/programas/portaria/autorizacao_acesso',
        element: <AutorizacaoDeAcesso />,
      },
      {
        path: '/programas/financeiro/caixa/:idRegistro',
        element: <CaixaFechamento />,
      },
      {
        path: '/programas/financeiro_fechamento/caixa/:idRegistro',
        element: <CaixaFechamento />,
      },
      {
        path: '/programas/financeiro_loja/ponto_de_venda/:urlIdPedidoVenda?/:urlIdPontoVenda?',
        element: <PontoDeVenda />,
      },
      {
        path: '/programas/farmacia/dispensacao',
        element: <Dispensacao />,
      },
      {
        path: '/programas/enfermagem/programacao_agenda',
        element: <ProgramacaoAgendamento />,
      },
      {
        path: '/programas/usuario/usuario_senha',
        element: <UsuarioEdicaoSenha />,
      },
      {
        path: '/programas/formulario/publico',
        element: <RespostaQuestionarioPublico />,
      },
      {
        path: '/programas/atendimento/modelo_documento',
        element: <ModeloDocumento />,
      },
      {
        path: '/programas/consultorio/receita_avulsa',
        element: <ReceitasAvulsas />,
      },
      {
        path: '/programas/financeiro_loja/orcamento_checkin',
        element: <OrcamentoCheckin />,
      },
      {
        path: '/programas/financeiro_loja/orcamento_checkout',
        element: <Checkout />,
      },

      {
        path: '/programas/atendimento/fluxo_atendimento',
        element: <FluxoAtendimento />,
      },
      {
        path: '/programas/enfermagem/aplicacao_medicamento',
        element: <AplicacaoMedicamento />,
      },
      {
        path: '/programas/enfermagem/atendimento_externo',
        element: <AtendimentoExterno />,
      },
      {
        path: '/programas/enfermagem/programacao_agenda_checkin',
        element: <ProgramacaoAgendamentoCheckin />,
      },

      {
        path: '/programas/financeiro_fechamento/nota_fiscal',
        element: <CtrlNotaFiscal />,
      },
      {
        path: '/programas/relatorios/atendimento_checkin',
        element: <RelatorioAtendimentoCheckin />,
      },
      {
        path: '/programas/relatorios/atendimento_transfer',
        element: <RelatorioTransfer />,
      },
      {
        path: '/programas/relatorios/atendimento_hotelaria',
        element: <RelatorioInformacoesHotelaria />,
      },
      {
        path: '/programas/relatorios/aplicacoes_enfermagem',
        element: <RelatorioAplicacoesEnfermagem />,
      },
      {
        path: '/programas/administracao/questionario',
        element: <CtrlQuestionario />,
      },
      {
        path: '/programas/relatorios/ficha_comercial',
        element: <RelatorioFichaComercial />,
      },
      {
        path: '/programas/relatorios/aniversariantes',
        element: <RelatorioAniversariantes />,
      },
      {
        path: '/programas/relatorios/produto_a_vencer',
        element: <RelatorioProdutosAVencer />,
      },
      {
        path: '/programas/relatorios/saidas_estoque',
        element: <RelatorioSaidasEstoque />,
      },
      {
        path: '/programas/financeiro/pagamento_comissao',
        element: <GestaoDeComissoes />,
      },
      {
        path: '/programas/financeiro/cheques',
        element: <Cheque />,
      },
      {
        path: '/programas/relatorios/vendas_por_centro_custo',
        element: <RelatorioVendasPorCentroDeCusto />,
      },
      {
        path: '/programas/relatorios/vendas_por_plano_conta',
        element: <RelatorioVendasPorPlanoDeConta />,
      },
      {
        path: '/programas/relatorios/fluxo_de_caixa',
        element: <RelatorioFluxoDeCaixa />,
      },
      {
        path: '/programas/relatorios/cheque',
        element: <RelatorioCheque />,
      },
      {
        path: '/programas/campanha/gestao_campanha',
        element: <Campanha />,
      },
      {
        path: '/programas/enfermagem/paciente_evolucao_enfermagem',
        element: <PacienteEvolucaoEnfermagem />,
      },
      {
        path: '/programas/portaria/atendimento_portaria',
        element: <AtendimentoPortaria />,
      },
      {
        path: '/programas/relatorios/sinais_evolucao_enfermagem',
        element: <RelatorioSinaisEvolucaoEnfermagem />,
      },
      {
        path: '/programas/relatorios/ficha_terapia',
        element: <RelatorioInformacoesFichaTerapia />,
      },
      {
        path: '/programas/relatorios/adicionais_atendimento',
        element: <RelatorioAdicionalAtendimento />,
      },
      {
        path: '/programas/cadastro/agente_llm',
        element: <AgenteLLM />,
      },
    ],
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/publico/termo_consentimento_publico',
    element: <TermoConsentimentoPublico />,
  },
  {
    path: '/publico/receituario/:cdValidacao',
    element: <ValidadorDocumento />,
  },
  {
    path: '/agendamento_online',
    element: <AgendamentoOnline />,
  },
  {
    path: '/publico/teste/curva_crescimento',
    element: <TesteCurvaCrescimento />,
  },

  {
    path: '*',
    element: <Navigate to="/login" replace />,
  },
])
